import Compressor from 'compressorjs'
import { Indicator } from 'mint-ui'
export default {
  imageProcess (file, quality, success) {
    Indicator.open()
    if (!file) {
      return
    }
    if(quality === 0.5||quality===""){
        quality = 123;
    }
    if(file.size > 3435774){
      quality=0.5
    }else{
      quality=0.7
    }
    //console.log("file")
    console.log(file,"图片数据")
    // eslint-disable-next-line no-new
    new Compressor(file, {
      quality:quality,
      maxHeight: 2000,
      maxWidth: 2000,
      success (result) {
        console.log(result,"压缩后图片数据")
        Indicator.close()
        let newFile = new File([result], "default.jpg", {
          type: file.type,
          lastModified: file.lastModified
        })
        if(result.size==newFile.size){
          success(newFile)
        }else{
          success("fileErr")
        }
        //success(newFile)
      },
      error (err) {
        localStorage.setItem("CompressFileErr",err)
        Indicator.close()
        console.log(err.message)
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/utils/imageUtils.js



// WEBPACK FOOTER //
// ./src/utils/imageUtils.js